<template>
	<div>
		<leaflet-marker
			v-for="event of events"
			:key="event.id"
			:latitude="getCoordinate('latitude', event)"
			:longitude="getCoordinate('longitude', event)"
			:icon="getEventIcon(event)"
			:draggable="false"
			iconColor="blue"
			bringToFront
			isSelected
		/>
		<div
			v-for="subOrder of subOrders"
			:key="subOrder.id"
		>
			<leaflet-marker
				:latitude="getCoordinate('latitude', subOrder.despatchParty)"
				:longitude="getCoordinate('longitude', subOrder.despatchParty)"
				:icon="getOrderIcon(subOrder)"
				:iconColor="getOrderIconColor(subOrder)"
				:draggable="false"
				bringToFront
			/>
			<t-poly-line
				:points="getSubOrderPoints(subOrder)"
				:color="getOrderIconColor(subOrder)"
				:lineStyle="getOrderLineStyle(subOrder)"
				:width="3"
				addArrows
			/>
		</div>

		<leaflet-marker
			v-if="delivery"
			:latitude="Number(delivery.latitude)"
			:longitude="Number(delivery.longitude)"
			:icon="deliveryIcon"
			:draggable="false"
			iconColor="blue"
			bringToFront
		/>

		<!-- <t-poly-line
			:points="actualPoints"
			lineStyle="solid"
			color="#ee9913"
			:width="3"
		/> -->
	</div>
</template>

<script>
import createIconMixin from '@/components/map/CreateIcon.mixin.js';
import { statuses, goodsTypesIcons } from '@/core';

export default {
	name: 'MapOrder',
	mixins: [createIconMixin],
	props: { order: { type: Object, } },
	data() {
		return { position: null, };
	},
	computed: {
		subOrders() {
			if (!this.order || !this.order.subOrders) return [];
			return this.order.subOrders.filter(order => this.hasLatLng(order.despatchParty));
		},
		events() {
			if (!this.order || !this.order.events) return [];
			return this.order.events.filter(event => this.hasLatLng(event));
		},
		eventPoints() {
			return this.events.map(event => this.getLatLng(event));
		},
		delivery() {
			if (!this.order) return false;
			return this.order.deliveryParty;
		},
		deliveryIcon() {
			return this.createIcon({ iconName: 'trip-end', iconType: 'tim' });
		},
		allPoints() {
			let points = [];
			this.eventPoints.forEach(point => points.push(point));
			if (this.delivery) {
				points.push(this.getLatLng(this.delivery));
			}

			return points;
		}
	},
	methods: {
		getSubOrderPoints(subOrder) {
			let points = [];
			if (subOrder.despatchParty)
				points.push(this.getLatLng(subOrder.despatchParty));
			if (subOrder.deliveryParty)
				points.push(this.getLatLng(subOrder.deliveryParty));

			return points;
		},
		getCoordinate(key, coords) {
			if (!coords || !key || !coords[key]) return 0;
			return Number(coords[key]);
		},
		getLatLng(obj) {
			if (this.hasLatLng(obj)) {
				return { latitude: Number(obj.latitude), longitude: Number(obj.longitude) };
			}
			return null;
		},
		hasLatLng(obj) {
			return obj && obj.latitude && obj.longitude;
		},
		getOrderIcon(order) {
			let goodsTypeKey = order.goodsType ? order.goodsType.key : undefined;
			let orderIcon = goodsTypesIcons(goodsTypeKey);
			return this.createIcon({ iconName: orderIcon, iconType: 'tim' });
		},
		getOrderIconColor(order) {
			return statuses.color(order.status);
		},
		getOrderLineStyle(subOrder) {
			return subOrder.ata ? 'solid' : 'dashed';
		},
		getEventIcon(event) {
			switch (event.type) {
			case 'loaded':
				return this.createIcon({ iconName: 'pickup', iconType: 'tim', iconSize: 1, iconOffset: [ 0, 3 ] });
			case 'unloaded':
				return this.createIcon({ iconName: 'delivery', iconType: 'tim', iconSize: 1, iconOffset: [ 0, 3 ] });
			default:
				return this.createIcon({ iconName: 'map-marker', iconType: 'bp', iconOffset: [ -0.5, -0.5 ] });
			}
		},
	}
};
</script>

<style lang="scss" scoped>

</style>